var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "component-calculator" }, [
    _c("div", { staticClass: "calculator-wrap wrap" }, [
      _c("p", { staticClass: "calculator-title" }, [
        _vm._v("НДФЛка найдет для вас максимальный возврат")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calculator-content" }, [
        _c(
          "div",
          { staticClass: "calculator-steps" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === 1,
                    expression: "step === 1"
                  }
                ],
                staticClass: "calculator-step"
              },
              [
                _c("p", { staticClass: "calculator-question" }, [
                  _vm._v("Вы платите ипотеку?")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "calculator-question-description" }, [
                  _vm._v("Проценты по ипотеке — это ещё +13% к возврату!")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "calculator-answers" }, [
                  _c("label", { staticClass: "calculator-answer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.calculator.mortgage,
                          expression: "calculator.mortgage"
                        }
                      ],
                      staticClass: "answer-input",
                      attrs: { type: "radio", name: "answer-mortgage" },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.calculator.mortgage, true)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.calculator, "mortgage", true)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "answer-text" }, [_vm._v("Да")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.calculator.mortgage === true,
                            expression: "calculator.mortgage === true"
                          }
                        ],
                        staticClass: "answer-description"
                      },
                      [_vm._v("Банки в шоке! За проценты вернём до 390 000 ₽")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "calculator-answer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.calculator.mortgage,
                          expression: "calculator.mortgage"
                        }
                      ],
                      staticClass: "answer-input",
                      attrs: { type: "radio", name: "answer-mortgage" },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.calculator.mortgage, false)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.calculator, "mortgage", false)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "answer-text" }, [_vm._v("Нет")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.calculator.mortgage === false,
                            expression: "calculator.mortgage === false"
                          }
                        ],
                        staticClass: "answer-description"
                      },
                      [
                        _vm._v(
                          "Значит, не придётся вспоминать график платежей. Отлично!"
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "calculator-form",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        _vm.step++
                      }
                    }
                  },
                  [
                    _vm.calculator.mortgage !== null && !_vm.isUser
                      ? _c("div", { staticClass: "calculator-field" }, [
                          _c("div", { staticClass: "form-field" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.firstname,
                                  expression: "firstname"
                                }
                              ],
                              staticClass: "input",
                              attrs: {
                                name: "calculator_firstname",
                                autocomplete: "off",
                                placeholder: "Как Вас зовут?",
                                type: "text",
                                required: ""
                              },
                              domProps: { value: _vm.firstname },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.firstname = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "calculator-field-description" },
                            [_vm._v("Чтобы мы обращались к вам по имени")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "auth-buttons-wrap" },
                            [
                              _c("p", { staticClass: "auth-description" }, [
                                _vm._v("Продолжить в одно касание:")
                              ]),
                              _vm._v(" "),
                              _c("third-auth-buttons", {
                                attrs: {
                                  preClickEvent: _vm.saveCalculatorProgress
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "calculator-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button button-gradient button-next",
                          attrs: {
                            type: "submit",
                            disabled: _vm.calculator.mortgage === null
                          }
                        },
                        [
                          _vm._v(
                            "\n                               Далее\n                           "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === 2,
                    expression: "step === 2"
                  }
                ],
                staticClass: "calculator-step"
              },
              [
                _c("p", { staticClass: "calculator-question" }, [
                  _vm._v("Вы покупали квартиру/дом/участок?")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "calculator-question-description" }, [
                  _vm._v("Даже если давно — всё равно можно вернуть налог!")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "calculator-answers" }, [
                  _c("label", { staticClass: "calculator-answer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.calculator.estate,
                          expression: "calculator.estate"
                        }
                      ],
                      staticClass: "answer-input",
                      attrs: { type: "radio", name: "answer-estate" },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.calculator.estate, true)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.calculator, "estate", true)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "answer-text" }, [_vm._v("Да")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.calculator.estate === true,
                            expression: "calculator.estate === true"
                          }
                        ],
                        staticClass: "answer-description"
                      },
                      [
                        _vm._v(
                          "Круто! Вы только что нашли до 260 000 ₽. Поехали дальше?"
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "calculator-answer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.calculator.estate,
                          expression: "calculator.estate"
                        }
                      ],
                      staticClass: "answer-input",
                      attrs: { type: "radio", name: "answer-estate" },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.calculator.estate, false)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.calculator, "estate", false)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "answer-text" }, [_vm._v("Нет")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.calculator.estate === false,
                            expression: "calculator.estate === false"
                          }
                        ],
                        staticClass: "answer-description"
                      },
                      [_vm._v("Экономите на агентах по недвижимости? Умно!")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "calculator-buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button button-prev",
                      on: {
                        click: function($event) {
                          _vm.step--
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                            Назад\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button button-gradient button-next",
                      attrs: { disabled: _vm.calculator.estate === null },
                      on: {
                        click: function($event) {
                          _vm.step++
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                            Далее\n                        "
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === 3,
                    expression: "step === 3"
                  }
                ],
                staticClass: "calculator-step"
              },
              [
                _c("p", { staticClass: "calculator-question" }, [
                  _vm._v(
                    _vm._s(_vm.displayedFirstname) +
                      ", вы тратились на врачей, анализы, лекарства, ДМС? "
                  ),
                  _c("br"),
                  _vm._v("Вы или ваш ребенок учились платно?")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "calculator-question-description" }, [
                  _vm._v(
                    "Даже обычный чек на таблетки и расходы на детский сад могут вернуть деньги в семью!"
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "calculator-answers" }, [
                  _c("label", { staticClass: "calculator-answer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.calculator.social,
                          expression: "calculator.social"
                        }
                      ],
                      staticClass: "answer-input",
                      attrs: { type: "radio", name: "answer-social" },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.calculator.social, true)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.calculator, "social", true)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "answer-text" }, [_vm._v("Да")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.calculator.social === true,
                            expression: "calculator.social === true"
                          }
                        ],
                        staticClass: "answer-description"
                      },
                      [
                        _vm._v(
                          "Здорово! Вернём до 15 600 ₽ в год, и до 300 000 ₽ за дорогостоящее лечение"
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "calculator-answer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.calculator.social,
                          expression: "calculator.social"
                        }
                      ],
                      staticClass: "answer-input",
                      attrs: { type: "radio", name: "answer-social" },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.calculator.social, false)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.calculator, "social", false)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "answer-text" }, [_vm._v("Нет")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.calculator.social === false,
                            expression: "calculator.social === false"
                          }
                        ],
                        staticClass: "answer-description"
                      },
                      [_vm._v("Видимо, у вас железный иммунитет. Завидуем!")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "calculator-form",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.checkPhoneStep($event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.calculator.social !== null && !_vm.isUser,
                            expression: "calculator.social !== null && !isUser"
                          }
                        ],
                        staticClass: "calculator-field"
                      },
                      [
                        _c("div", { staticClass: "form-field" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.phone,
                                expression: "phone"
                              }
                            ],
                            staticClass: "input masked-phone",
                            attrs: {
                              id: "calculator_phone",
                              autocomplete: "off",
                              placeholder: "Ваш мобильный телефон",
                              type: "tel"
                            },
                            domProps: { value: _vm.phone },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.phone = $event.target.value
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "calculator-field-description" },
                          [
                            _vm._v(
                              "Для быстрой связи. Обещаем не звонить с рекламой!"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "auth-buttons-wrap" },
                          [
                            _c("p", { staticClass: "auth-description" }, [
                              _vm._v("Продолжить в одно касание:")
                            ]),
                            _vm._v(" "),
                            _c("third-auth-buttons", {
                              attrs: {
                                preClickEvent: _vm.saveCalculatorProgress
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "calculator-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button button-prev",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.step--
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                Назад\n                            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button button-gradient button-next",
                          attrs: {
                            type: "submit",
                            disabled: _vm.calculator.social === null
                          }
                        },
                        [
                          _vm._v(
                            "\n                                Далее\n                            "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === 4,
                    expression: "step === 4"
                  }
                ],
                staticClass: "calculator-step"
              },
              [
                _c("p", { staticClass: "calculator-question" }, [
                  _vm._v(
                    _vm._s(_vm.displayedFirstname) +
                      ", у вас есть ИИС или вы покупали акции/облигации (даже через приложение банка)?"
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "calculator-answers" }, [
                  _c("label", { staticClass: "calculator-answer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.calculator.investment,
                          expression: "calculator.investment"
                        }
                      ],
                      staticClass: "answer-input",
                      attrs: { type: "radio", name: "answer-investment" },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.calculator.investment, true)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.calculator, "investment", true)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "answer-text" }, [_vm._v("Да")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.calculator.investment === true,
                            expression: "calculator.investment === true"
                          }
                        ],
                        staticClass: "answer-description"
                      },
                      [
                        _vm._v(
                          "Уолл-Стрит отдыхает! Минимум + 52 000 ₽ в год и еще вернем налог с убытков"
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "calculator-answer" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.calculator.investment,
                          expression: "calculator.investment"
                        }
                      ],
                      staticClass: "answer-input",
                      attrs: { type: "radio", name: "answer-investment" },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.calculator.investment, false)
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.calculator, "investment", false)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "answer-text" }, [_vm._v("Нет")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.calculator.investment === false,
                            expression: "calculator.investment === false"
                          }
                        ],
                        staticClass: "answer-description"
                      },
                      [_vm._v("Значит, не теряли деньги на Tesla. Мудро!")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "calculator-form",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        _vm.step++
                      }
                    }
                  },
                  [
                    _vm.calculator.investment !== null && !_vm.isUser
                      ? _c("div", { staticClass: "calculator-field" }, [
                          _c("div", { staticClass: "form-field" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.email,
                                  expression: "email"
                                }
                              ],
                              staticClass: "input",
                              attrs: {
                                name: "calculator_email",
                                autocomplete: "off",
                                placeholder: "Email",
                                type: "email",
                                required: ""
                              },
                              domProps: { value: _vm.email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.email = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "calculator-field-description" },
                            [
                              _vm._v(
                                "Пришлём расчёт и список документов. Проверьте, чтобы не было ошибок!"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "auth-buttons-wrap" },
                            [
                              _c("p", { staticClass: "auth-description" }, [
                                _vm._v("Продолжить в одно касание:")
                              ]),
                              _vm._v(" "),
                              _c("third-auth-buttons", {
                                attrs: {
                                  preClickEvent: _vm.saveCalculatorProgress
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "calculator-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button button-prev",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.step--
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                Назад\n                            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button button-gradient button-next",
                          attrs: {
                            type: "submit",
                            disabled: _vm.calculator.investment === null
                          }
                        },
                        [
                          _vm._v(
                            "\n                                Далее\n                            "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm.step === 5
              ? [
                  !_vm.isUser
                    ? [
                        !_vm.isAlreadyRegistered
                          ? [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.calculatorNumber,
                                      expression: "calculatorNumber"
                                    }
                                  ],
                                  staticClass: "calculator-step"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "calculator-registration-text"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.displayedFirstname) +
                                          ", мы нашли для вас " +
                                          _vm._s(
                                            _vm._f("formatCurrency")(
                                              _vm.calculatorNumber
                                            )
                                          ) +
                                          " ₽!\n                                    "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "Но это только начало — 72% клиентов получают больше\n                                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "calculator-registration-description"
                                    },
                                    [
                                      _vm._v(
                                        "Просто оформите заказ на «Максимальный вычет» в личном кабинете — и наш эксперт свяжется с вами, чтобы всё уточнить."
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button button-gradient button-registration",
                                      attrs: {
                                        disabled:
                                          _vm.isRegLoading ||
                                          _vm.isCalculatorLoading
                                      },
                                      on: {
                                        click: _vm.initCreateCalculatorOrder
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    вернуть максимум\n                                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.calculatorNumber,
                                      expression: "!calculatorNumber"
                                    }
                                  ],
                                  staticClass: "calculator-step"
                                },
                                [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button button-gradient button-registration",
                                      attrs: {
                                        disabled:
                                          _vm.isRegLoading ||
                                          _vm.isCalculatorLoading
                                      },
                                      on: {
                                        click: _vm.initCreateCalculatorOrder
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Узнать о новых вычетах\n                                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isAlreadyRegistered ? [_vm._m(3)] : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isUser
                    ? [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.calculatorNumber,
                                expression: "calculatorNumber"
                              }
                            ],
                            staticClass: "calculator-step"
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "calculator-registration-text" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.displayedFirstname) +
                                    ", мы нашли для вас " +
                                    _vm._s(
                                      _vm._f("formatCurrency")(
                                        _vm.calculatorNumber
                                      )
                                    ) +
                                    " ₽!\n                                "
                                ),
                                _c("br"),
                                _vm._v(
                                  "Но это только начало — 72% клиентов получают больше\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(4),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "calculator-registration-description"
                              },
                              [
                                _vm._v(
                                  "Просто оформите заказ на «Максимальный вычет» в личном кабинете — и наш эксперт свяжется с вами, чтобы всё уточнить."
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "button button-gradient button-registration",
                                attrs: {
                                  disabled:
                                    _vm.isRegLoading || _vm.isCalculatorLoading
                                },
                                on: { click: _vm.initCreateCalculatorOrder }
                              },
                              [
                                _vm._v(
                                  "\n                                Максимальный возврат\n                            "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.calculatorNumber,
                                expression: "!calculatorNumber"
                              }
                            ],
                            staticClass: "calculator-step"
                          },
                          [
                            _vm._m(5),
                            _vm._v(" "),
                            _vm._m(6),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "button button-gradient button-registration",
                                attrs: {
                                  disabled:
                                    _vm.isRegLoading || _vm.isCalculatorLoading
                                },
                                on: { click: _vm.initCreateCalculatorOrder }
                              },
                              [
                                _vm._v(
                                  "\n                                Найдите мне вычет\n                            "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    : _vm._e()
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "calculator-progress" },
          _vm._l(_vm.stepMax, function(stepNumber) {
            return _c(
              "div",
              {
                key: "calculator-progress-" + stepNumber,
                staticClass: "progress-block",
                class: { active: stepNumber <= _vm.step }
              },
              [
                _c("img", {
                  staticClass: "icon-coin coin-active",
                  attrs: {
                    src: "/img/svg/icon-calculator-coin.svg",
                    alt: "",
                    width: "24",
                    height: "24"
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "icon-coin coin-disabled",
                  attrs: {
                    src: "/img/svg/icon-calculator-coin-disabled.svg",
                    alt: "",
                    width: "24",
                    height: "24"
                  }
                })
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("p", { staticClass: "progress-description" }, [
          _vm._v("Осталось немного!")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  !_vm.isUser && _vm.step === 5 && !_vm.isAlreadyRegistered,
                expression: "!isUser && step === 5 && !isAlreadyRegistered"
              }
            ],
            staticClass: "form-checkbox"
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.privacy,
                  expression: "privacy"
                }
              ],
              staticClass: "checkbox",
              attrs: {
                id: "calculator-privacy",
                type: "checkbox",
                checked: "",
                required: "",
                name: "calculator-privacy"
              },
              domProps: {
                checked: Array.isArray(_vm.privacy)
                  ? _vm._i(_vm.privacy, null) > -1
                  : _vm.privacy
              },
              on: {
                change: function($event) {
                  var $$a = _vm.privacy,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.privacy = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.privacy = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.privacy = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _vm._m(7)
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "calculator-registration-text" }, [
      _vm._v("Хотите больше вычета — "),
      _c("br"),
      _vm._v("мы знаем, как это сделать!")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "calculator-registration-zero" }, [
      _vm._v("Кажется, вы — эталон финансовой дисциплины! "),
      _c("br"),
      _vm._v(
        "Наши алгоритмы проверили все возможные расходы, но… ваш кошелек оказался неуязвим для налоговых вычетов. "
      ),
      _c("br"),
      _vm._v("Так держать!")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "reg-advantages-block" }, [
      _c("p", { staticClass: "advantages-title" }, [
        _vm._v("Но вдруг что-то упустили? Зарегистрируйтесь — и мы:")
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "advantages-list" }, [
        _c("li", { staticClass: "advantages-list-item" }, [
          _vm._v("Напомним, когда появятся подходящие траты "),
          _c("br"),
          _vm._v("(ипотека, лечение, обучение)")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "advantages-list-item" }, [
          _vm._v("Первому из всех расскажем о новых вычетах")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "calculator-step" }, [
      _c("p", { staticClass: "calculator-registration-already-reg" }, [
        _vm._v(
          "Пользователь с такими данными уже зарегистрирован — войдите, пожалуйста, в свой личный кабинет"
        )
      ]),
      _vm._v(" "),
      _c("picture", [
        _c("source", {
          attrs: {
            srcset: "/img/door.jpg" + ", " + "/img/door@2x.jpg" + " 2x",
            type: "image/jpeg"
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "calculator-already-reg-image",
          attrs: {
            loading: "lazy",
            src: "/img/door.jpg",
            alt: "",
            width: "304",
            height: "264"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "button button-gradient button-login",
          attrs: { href: "/user/login/" }
        },
        [
          _vm._v(
            "\n                                    войти в личный кабинет\n                                "
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "calculator-registration-text" }, [
      _vm._v("Хотите больше вычета — "),
      _c("br"),
      _vm._v("мы знаем, как это сделать!")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "calculator-registration-zero" }, [
      _vm._v("Поздравляем! Вы нас озадачили. "),
      _c("br"),
      _vm._v("Наш алгоритм в ступоре — он не нашел ни одного вычета за вами")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "reg-advantages-block" }, [
      _c("p", { staticClass: "advantages-title" }, [
        _vm._v("Но мы не сдаемся! Оставьте заказ — и мы:")
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "advantages-list" }, [
        _c("li", { staticClass: "advantages-list-item" }, [
          _vm._v("Перепроверим прошлые годы (вдруг пропустили что-то?)")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "advantages-list-item" }, [
          _vm._v("Пришлем уведомление, как только появится новый вычет "),
          _c("br"),
          _vm._v("(например, купите квартиру/машину/золотого дракона)")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "label", attrs: { for: "calculator-privacy" } },
      [
        _vm._v(
          "\n                    Оставляя контактные данные, вы соглашаетесь с "
        ),
        _c(
          "a",
          {
            staticClass: "privacy-link",
            attrs: { href: "/documents/privacy/", target: "_blank" }
          },
          [_vm._v("политикой конфиденциальности")]
        ),
        _vm._v(
          " и даете согласние на обработку персональных данных, а также подтверждаете, что "
        ),
        _c(
          "a",
          {
            staticClass: "privacy-link",
            attrs: { href: "/documents/eula/", target: "_blank" }
          },
          [_vm._v("Ознакомлены и согласны с условиями Договора")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }